import React from 'react';
import { ModalBody } from '@lightspeed/flame/Modal';
import { Flex, flameTheme } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';
import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';
import Client from 'pages/views/devices/socketClient';
import { STATUS } from 'pages/views/devices/socketClient/types';
import { setHubEnabled, removeHubEnabled } from 'pages/views/devices/utils/storage';
import { CopyLink } from '../../components/CopyLink';
import { ScanCode } from '../../components/ScanCode';

interface DeviceConnectionProps {
  url: string;
  connectionStatus: typeof STATUS[keyof typeof STATUS];
}

const DeviceConnection: React.FC<DeviceConnectionProps> = ({ url, connectionStatus }) => {
  const isReady = connectionStatus === STATUS.READY;
  const { colors } = flameTheme;

  const handleConnect = () => {
    setHubEnabled();
    Client.connect();
  };

  return (
    <>
      <ModalBody data-test="device-connection-modal">
        <Flex pb={3} alignItems="stretch">
          <Card p={3} style={{ width: '45%' }}>
            <CopyLink url={url} />
          </Card>
          <Flex alignItems="center" m={3}>
            <Text fontWeight="bold">OR</Text>
          </Flex>
          <Card p={3} style={{ width: '45%' }}>
            <ScanCode url={url} />
          </Card>
        </Flex>

        {isReady ? (
          <Button block fill variant="secondary" onClick={handleConnect} disabled={isReady}>
            Connecting
          </Button>
        ) : (
          <>
            <Text color={colors.textDimmed} textAlign="center" mt={1} mb={3}>
              Connect here when your device is ready.
            </Text>
            <Button block fill variant="secondary" onClick={handleConnect} disabled={isReady}>
              Connect
            </Button>
          </>
        )}
        {isReady && (
          <Flex pt={1} justifyContent="center">
            <TextLink
              onClick={() => {
                removeHubEnabled();
                Client.disconnect();
              }}
            >
              Cancel and try again
            </TextLink>
          </Flex>
        )}
      </ModalBody>
    </>
  );
};

export { DeviceConnection };
